import Vue from 'vue'
import VIcon from '@/components/VIcon'
import VButton from '@/components/VButton'

Vue.component(VIcon.name, VIcon)
Vue.component(VButton.name, VButton)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
